import React from 'react';

const VideoPlayer = ({ videoUrl }) => {
  return (
    <div>
      <video
        width="100%"
        height="500"
        controls
        style={{ borderRadius: '8px', backgroundColor: 'black' }}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
